import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { FilterOrderInput } from './FilterOrderInput';
import { FilterOrderOutput } from './FilterOrderOutput';
import { FilterOrderForListingOutput } from './FilterOrderForListingOutput';
import { OrderForListingService } from '../OrderForListingService';

export class FilterOrderService extends HttpServiceBase {

  constructor(
    private orderForListingService: OrderForListingService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input?: FilterOrderInput): Promise<Result<FilterOrderOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<FilterOrderOutput>>(`${this.baseUrlSislogApi}/v2/order${parameters}`);
    return promise;
  }

  handleForListing = (input?: FilterOrderInput): Promise<Result<FilterOrderForListingOutput> | null> => {
    if (input) input.secondsDelayToFilter = 60;
    const promise = new Promise<Result<FilterOrderForListingOutput> | null>(async (resolve, reject) => {
      const result = await this.handle(input);

      if (!result) {
        resolve(null);
        return;
      }

      const resultForListing = new Result<FilterOrderForListingOutput>();

      if (!result.value) {
        resolve(resultForListing);
        return;
      }

      const log: any[] = [];

      const outputForListing = new FilterOrderForListingOutput();
      outputForListing.amountOfPages = result.value.amountOfPages;
      outputForListing.currentPage = result.value.currentPage;
      outputForListing.currentPageSize = result.value.currentPageSize;
      outputForListing.totalAmount = result.value.totalAmount;
      outputForListing.list = result.value.list.map(orderState => {
        const orderForListing = this.orderForListingService.orderStateToOrderForListing(orderState);
        log.push({
          id: orderForListing.order.id,
          number: orderForListing.order.number,
          customer: orderForListing.order.customer?.name,
          stateLog: orderForListing.currentStateName,
          statePrescription: orderForListing.currentStatePrescriptionName
        });
        return orderForListing;
      });

      if (input?.orderAlertType && input.orderAlertType > 0) {
        outputForListing.list = outputForListing.list.filter(item => item._alerts.some(a => a.type === input.orderAlertType));
        outputForListing.totalAmount = outputForListing.list.length;
      }

      resultForListing.value = outputForListing;

      resolve(resultForListing);
    });
    return promise;
  }
}